import { ErrorEntry } from '../types';

type FormattedErrors<TField extends string, TError extends string> = Partial<Record<TField, TError[]>>;

export function formatErrorKeys<TField extends string, TError extends string>(
    errorKeys: ErrorEntry<TField, TError>[]
): FormattedErrors<TField, TError> {
    return errorKeys.reduce<FormattedErrors<TField, TError>>((acc, [key, value]) => {
        const existingValue = acc[key] || [];
        acc[key] = [...existingValue, value];

        return acc;
    }, {});
}
